import { render } from "./createdPost.vue?vue&type=template&id=4d92924e&scoped=true"
import script from "./createdPost.vue?vue&type=script&lang=js"
export * from "./createdPost.vue?vue&type=script&lang=js"

import "./createdPost.vue?vue&type=style&index=0&id=4d92924e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d92924e"]])

export default __exports__